/**
 * API configuration constants.
 *
 * Update these values based on your OCAPI environment.
 */

/**
 * Runtime catalog ID storage.
 * Set from server loader data or falls back to build-time env var.
 */
let runtimeCatalogId: string | null = null

/**
 * Set the catalog ID from runtime environment.
 */
export function setRuntimeCatalogId(catalogId: string): void {
    if (catalogId) {
        runtimeCatalogId = catalogId
    }
}

/**
 * Get the catalog ID to use for category searches.
 * Prioritizes runtime value, then build-time env var, then default.
 */
export function getCatalogId(): string {
    return runtimeCatalogId || import.meta.env.VITE_CATALOG_ID || 'cnv-storefront-catalog-us'
}

/**
 * The catalog ID to use for category searches.
 * This should match Salesforce Commerce Cloud catalog.
 * @deprecated Use getCatalogId() instead for runtime support
 */
export const CATALOG_ID = getCatalogId()

/**
 * Default number of results to return per search.
 */
export const DEFAULT_PAGE_SIZE = 100 as const
